/** Internal dependencies */
import { apiCall } from '../apiCall';
import { getCurrentFilters } from '../getCurrentFilters';
import { resetPagination } from '../resetPagination';

/**
 * Event handler for the active filters container. Resets correct dropdown filters on remove click.
 *
 * @author rafhun <rafhun@cubetech.ch>
 *
 * @param {Event} e
 * @returns void
 */
export function handleActiveFiltersContainer(e) {
    const target = e.target.closest('button');
    if (!target) {
        return;
    }

    const parent = target.closest('[data-ct-rest]');
    const { ctFilterTaxonomy, ctFilterTerm } = target.dataset;
    const input = parent.querySelector(`input[name="${ctFilterTaxonomy}"][value="${ctFilterTerm}"]`);
    if (input) {
        input.checked = false;
        target.remove();
        resetPagination(parent);
        const currentFilters = getCurrentFilters(parent);
        apiCall(parent, currentFilters, true);
    }
}
